import { render, staticRenderFns } from "./ExtensionWarningPopup.vue?vue&type=template&id=2bf598cf&scoped=true&"
import script from "./ExtensionWarningPopup.vue?vue&type=script&lang=js&"
export * from "./ExtensionWarningPopup.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionWarningPopup.vue?vue&type=style&index=0&id=2bf598cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf598cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf598cf')) {
      api.createRecord('2bf598cf', component.options)
    } else {
      api.reload('2bf598cf', component.options)
    }
    module.hot.accept("./ExtensionWarningPopup.vue?vue&type=template&id=2bf598cf&scoped=true&", function () {
      api.rerender('2bf598cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExtensionWarningPopup.vue"
export default component.exports